import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import {ListSubheader} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import React from "react";
import Paper from "@mui/material/Paper";
import {styled} from "@mui/material/styles";
import {s_char} from "../_signals/s_char";
import {useSignals} from "@preact/signals-react/runtime";
import updChar from "../_sig_api/updChar";


const Item = styled(Paper)(({theme}) => ({
    backgroundColor: '#fff', ...theme.typography.body2, padding: 4, height: '100%', textAlign: 'center', color: '#000',
}));

function CharRace() {

    useSignals();

    const handleRaceChange = (target) => {
        updChar([{k: 'race', v: target.target.value}]);
    }


    return <>
        {!s_char.value.cc_attr ?
            <FormControl className={'vs-select'} variant="outlined"
                         style={{
                             minWidth: 120,
                             float: 'right',
                             margin: 8,
                             display: 'flex',
                             alignItems: 'center'
                         }}>
                <Select key="race"
                        defaultValue={s_char.value.race ?? ''}
                        onChange={handleRaceChange}
                        label="Rasse"
                        variant="outlined" style={{margin: '8px', minWidth: 120}}
                >
                    <ListSubheader>Rasse</ListSubheader>
                    <MenuItem key={'race_elf'} value={'elf'}>Elf</MenuItem>)
                    <MenuItem key={'race_mensch'} value={'mensch'}>Mensch</MenuItem>)
                    <MenuItem key={'race_obsidianer'} value={'obsidianer'}>Obsidianer</MenuItem>)
                    <MenuItem key={'race_ork'} value={'ork'}>Ork</MenuItem>)
                    <MenuItem key={'race_troll'} value={'troll'}>Troll</MenuItem>)
                    <MenuItem key={'race_tskrang'} value={'tskrang'}>T’skrang</MenuItem>)
                    <MenuItem key={'race_windling'} value={'windling'}>Windling</MenuItem>)
                    <MenuItem key={'race_zwerg'} value={'zwerg'}>Zwerg</MenuItem>)
                </Select>
            </FormControl>
            :
            <Item style={{fontSize: 'small', padding: 10}}>
                {s_char.value.race}
            </Item>

        }
    </>
}

export default CharRace;